import { createReducer } from "@reduxjs/toolkit";
import moment from "moment";
import { makeRRulefromEvent } from "~/components/Calendar/calendarUtils";
import {
  ADD_CALENDAR_EVENT_SUCCESS,
  ADD_COMMENT_LOADING,
  DELETE_CALENDAR_EVENT_SUCCESS,
  EDIT_CALENDAR_EVENT_ERROR,
  EDIT_CALENDAR_EVENT_LOADING,
  EDIT_CALENDAR_EVENT_SUCCESS,
  FETCH_ACTIVITY_LOGS_SUCCESS,
  FETCH_CALENDAR_EVENT_SUCCESS,
  MOVE_CALENDAR_EVENT_TO_TRASH_SUCCESS,
  MOVE_COMMENT_TO_TRASH_SUCCESS,
  PREFETCH_CALENDAR_EVENT_SUCCESS,
  RESTORED_CALENDAR_EVENT_FROM_TRASH_SUCCESS,
  FETCH_WORKLOAD_CALENDAR_EVENTS_SUCCESS,
  MOVE_CALENDAR_EVENTS_TO_TRASH_FROM_EVENT_STREAM_BY_CALENDAR_ID,
  RESCHEDULE_ONLY_THIS_CALENDAR_EVENT_SUCCESS,
  RESCHEDULE_EXCEPTION_CALENDAR_EVENT_LOADING,
  RESCHEDULE_THIS_AND_FUTURE_CALENDAR_EVENTS_SUCCESS,
  RESCHEDULE_ALL_CALENDAR_EVENTS_SUCCESS,
  RESCHEDULE_EXCEPTION_CALENDAR_EVENT_ERROR,
} from "~/store/action_types";
import {
  deleteCalendarEventFromEventStream,
  setCalendarEventFromEventStream,
} from "~/store/actions/actions.calendarEvents";

const reducer = createReducer({}, (builder) => {
  builder
    .addCase(ADD_COMMENT_LOADING, (state, action) => {
      if (!action.parentId || action.parentType !== "CalendarEvent" || !state[action.parentId.toString()]) {
        return state;
      }
      const selectedEvent = state[action.parentId.toString()];
      return {
        ...state,
        [action.parentId.toString()]: {
          ...selectedEvent,
          comments_count: selectedEvent.comments_count ? selectedEvent.comments_count + 1 : 1,
        },
      };
    })
    .addCase(MOVE_COMMENT_TO_TRASH_SUCCESS, (state, action) => {
      if (!action.parentId || action.parentType !== "CalendarEvent" || !state[action.parentId.toString()]) {
        return state;
      }
      const selectedEvent = state[action.parentId.toString()];
      return {
        ...state,
        [action.parentId.toString()]: {
          ...selectedEvent,
          comments_count: selectedEvent.comments_count ? selectedEvent.comments_count - 1 : 0,
        },
      };
    })

    .addCase(setCalendarEventFromEventStream, (state, action) => {
      const { payload = {} } = action;
      const { entities = {} } = payload;
      const { calendarEvents } = entities;
      if (calendarEvents) {
        return {
          ...state,
          ...calendarEvents,
        };
      }
      return state;
    })
    .addCase(deleteCalendarEventFromEventStream, (state, action) => {
      const { id } = action.payload;
      if (id) {
        const { [id]: _deleted, ...rest } = state;
        return rest;
      }
      return state;
    })
    .addCase(DELETE_CALENDAR_EVENT_SUCCESS, (state, action) => {
      const { id = 0 } = action;
      if (id) {
        const { [id]: _deleted, ...rest } = state;
        return rest;
      }
      return state;
    })
    .addCase(MOVE_CALENDAR_EVENTS_TO_TRASH_FROM_EVENT_STREAM_BY_CALENDAR_ID, (state, action) => {
      const calendarId = action.payload;
      if (calendarId) {
        const events = Object.values(state)?.filter((event) => event.calendar_id === calendarId);
        if (events) {
          events.forEach((event) => {
            state = {
              ...state,
              [event.id]: {
                ...event,
                is_trashed: true,
              },
            };
          });
        }
      }
      return state;
    })
    .addMatcher(
      (action) => [EDIT_CALENDAR_EVENT_ERROR, RESCHEDULE_EXCEPTION_CALENDAR_EVENT_ERROR].includes(action.type),
      (state, action) => {
        const { id = 0, _previous = {} } = action;
        if (id && _previous) {
          state[id] = _previous;
        }
        return state;
      }
    )
    .addMatcher(
      (action) => [EDIT_CALENDAR_EVENT_LOADING, RESCHEDULE_EXCEPTION_CALENDAR_EVENT_LOADING].includes(action.type),
      (state, action) => {
        const { id = 0, attributes = {} } = action;
        if (id) {
          state[id] = {
            ...state[id],
            ...attributes,
          };
          if (attributes?.repeat_until) {
            state[id] = {
              ...state[id],
              repeat_until: moment.utc(`${attributes.repeat_until} 00:00:00`).unix(),
            };
          }
          if (attributes?.starts_on && attributes?.ends_on) {
            let start_on = moment.utc(`${attributes.starts_on} 00:00:00`).unix();
            let ends_on = moment.utc(`${attributes.ends_on} 00:00:00`).unix();
            if (attributes.starts_on_time && attributes.ends_on_time) {
              start_on = moment(`${attributes.starts_on} ${attributes.starts_on_time}`).utc().unix();
              ends_on = moment(`${attributes.ends_on} ${attributes.ends_on_time}`).utc().unix();
            }

            state[id] = {
              ...state[id],
              starts_on: start_on,
              ends_on: ends_on,
            };
          }
          state[id] = {
            ...state[id],
            rrule: makeRRulefromEvent(state[id]),
          };
        }
        return state;
      }
    )
    .addMatcher(
      (action) =>
        [
          ADD_CALENDAR_EVENT_SUCCESS,
          EDIT_CALENDAR_EVENT_SUCCESS,
          FETCH_CALENDAR_EVENT_SUCCESS,
          PREFETCH_CALENDAR_EVENT_SUCCESS,
          MOVE_CALENDAR_EVENT_TO_TRASH_SUCCESS,
          RESTORED_CALENDAR_EVENT_FROM_TRASH_SUCCESS,
          FETCH_ACTIVITY_LOGS_SUCCESS,
          FETCH_WORKLOAD_CALENDAR_EVENTS_SUCCESS,
          RESCHEDULE_ONLY_THIS_CALENDAR_EVENT_SUCCESS,
          RESCHEDULE_THIS_AND_FUTURE_CALENDAR_EVENTS_SUCCESS,
          RESCHEDULE_ALL_CALENDAR_EVENTS_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { entities = {} } = response;
        const { calendarEvents } = entities;
        if (calendarEvents) {
          return {
            ...state,
            ...calendarEvents,
          };
        }
        return state;
      }
    );
});

export default reducer;
